export default function InterCarImage(){


    return(
        <>
            <div className="darkness-background">
                <h1>Interior of the Future</h1>
            </div>
            <section className="car-interior"></section>
        </>
    )
}